import React from 'react';
import {FaArrowRight } from 'react-icons/fa';
import '../Styles/CourseSection.css';
import courseImage1 from '../Assets/healthandcare.png'; // Placeholder image, replace with actual image path
import courseImage2 from '../Assets/softSkill.png'; // Placeholder image, replace with actual image path
import courseImage3 from '../Assets/language.png'; // Placeholder image, replace with actual
import courseImage4 from '../Assets/MBA.png'; // Placeholder image, replace with actual image path
const CoursesSection = () => {
  return (
    <section className="courses-container" id='courses'>
      <p className="section-label">Courses</p>
      <h2 className="section-heading">Empowering Corporates and Campus to Corporate students.</h2>
      <p className="section-description">
        Join me as we dive into the essentials of US Medical Healthcare, Language Training, Soft Skills, and Management MBA.
Whether you're aiming to start a career in healthcare, improve your communication, sharpen your workplace skills, or grow in management, these courses are designed to guide you through real-world challenges with clarity and confidence.
      </p>

      <div className="courses-grid">
        <div className="course-item">
          <div className="icon-circle">
           <img src={courseImage1} alt='courses' className='course-image'/>
          </div>
          <h3 className="course-title">Us Medical Health and care</h3>
          <p className="course-description">
          The US Medical Health and Care course provides essential insights into the American healthcare system, patient care practices, and medical standards. 
          It equips learners with knowledge of health policies, clinical guidelines, and ethical responsibilities in the U.S. context.
          </p>
        </div>

        <div className="course-item">
          <div className="icon-circle">
           <img src={courseImage3} alt='courses' className='course-image'/>
          </div>
          <h3 className="course-title">Language Training</h3>
          <p className="course-description">
           The Language Training course is designed to build strong communication skills in English and other global languages. It focuses on speaking, writing, listening, and comprehension to enhance personal and professional growth. 
           Learners gain the confidence to interact effectively in academic, workplace, and social environments.
          </p>
        </div>

        <div className="course-item">
          <div className="icon-circle">
           <img src={courseImage2} alt='courses' className='course-image'/>
          </div>
          <h3 className="course-title">Soft Skills</h3>
          <p className="course-description">
          The Soft Skills course focuses on developing essential interpersonal abilities such as communication, teamwork, leadership, and problem-solving.
           It prepares learners to adapt to professional environments with confidence and emotional intelligence.
          </p>
        </div>
        <div className="course-item">
          <div className="icon-circle">
           <img src={courseImage4} alt='courses' className='course-image'/>
          </div>
          <h3 className="course-title">Management MBA</h3>
          <p className="course-description">
           The MBA in Management course equips learners with advanced business knowledge, leadership strategies, and decision-making skills. It covers key areas such as finance, marketing, operations, and organizational behavior to prepare future leaders.
          </p>
        </div>
      </div>

      <div className="button-container">
        <a href="https://gainwisdom.in" target="_blank" rel="noreferrer" className="explore-button">
          Explore courses <FaArrowRight className="arrow-icon" />
        </a>
      </div>
    </section>
  );
};

export default CoursesSection;
